import {
  Modal,
  Toggle,
  Select as EDSelect,
  Snackbar,
  Snack,
  Button,
  TextField,
} from '@nike/eds';
import { useState, useEffect, useRef } from 'react';
import { nanoid } from 'nanoid';
import timestampToDate from '../../utils/dateHelpers';
import HotsearchClient from '../../clientAPI/hotsearch';
import './HotsearchRankingList.module.css';

type TypeSelectOption = { value: RankingListType; label: string };

type RankingListPreviewProps = {
  onDismiss: () => void;
  updateItem: (msg: string) => void;
  showModal: boolean;
  mode: Mode;
  canWrite: boolean;
  itemId: string;
};

const loadTypeOptions = [
  { value: 'CUSTOMIZE', label: 'HOT SERACH' } as TypeSelectOption,
  { value: 'GENERIC', label: 'PRODUCT' } as TypeSelectOption,
];

type ChannelOption = { value: string; label: string };

export default function RankingListMetaDataAddAndEdit(
  props: RankingListPreviewProps,
) {
  console.log('props', props);
  const [sort, setSort] = useState<string>('');
  const [customeType, setCustomeType] = useState<RankingListType>();
  const [enable, setEnable] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [hotSearchType, setHotSearchType] = useState<
    TypeSelectOption | undefined
  >();

  const channelOptions = [
    { value: '82a74ac1-c527-4470-b7b0-fb5f3ef3c2e2', label: 'Nike App' },
    { value: 'd9a5bc42-4b9c-4976-858a-f159cf99c647', label: 'Nike.COM' },
    { value: '15d92135-394e-487a-8afa-f6c8525c9ea9', label: 'WeChat' },
    { value: '008be467-6c78-4079-94f0-70e2d6cc4003', label: 'SNKRS' },
  ];
  const sortRef = useRef<HTMLInputElement>(null);
  const [channel, setChannel] = useState<ChannelOption[]>();
  const [channelMultiSelect, setChannelMultiSelect] = useState(false);

  const [typeErrorMsg, setTypeErrorMsg] = useState('');
  const [typeError, setTypeError] = useState(false);

  const [startDateErrorMsg, setStartDateErrorMsg] = useState('');
  const [startDateError, setStartateError] = useState(false);

  const [endDateErrorMsg, setEndDateErrorMsg] = useState('');
  const [endDateError, setEndError] = useState(false);

  const [sortErrorMsg, setSortErrorMsg] = useState('');
  const [sortError, setSortError] = useState(false);

  const startDateRef = useRef<HTMLInputElement>(null);
  const endDateRef = useRef<HTMLInputElement>(null);

  const [channeErrorlMsg, setChannelErrorMsg] = useState('');
  const [channelError, setChannelrror] = useState(false);
  const channelRef = useRef<any>();

  const [hasError, setHasError] = useState(false);

  const [isImmediately, setIsImmediately] = useState(false);

  const displayController = {
    not_displayed: 'not_displayed',
    display: 'display',
  };

  const [errorMsg, setErrorMsg] = useState(displayController.not_displayed);
  const typeRef = useRef<any>();
  useEffect(() => {
    if (props.mode == 'ADD') {
      return;
    }
    fetchAndConvertToRankingDetail().then((response) => {
      setSort(response.source.order + '');
      setCustomeType(response.source.type as RankingListType);
      setChannelMultiSelect(response.source.type == 'GENERIC');
      setStartDate(timestampToDate(response.source.startTime));
      setEndDate(timestampToDate(response.source.endTime));
      setEnable(response.source.enable);
      setIsImmediately(response.published != null);
      const initChannelIds: ChannelOption[] = response.source.channelIds.map(
        (channelId, index) => {
          return {
            value: channelId,
            label: channelOptions.find((v) => v.value === channelId)?.label,
          } as ChannelOption;
        },
      );
      setChannel(initChannelIds);
      setHotSearchType({
        value: response.source.type,
        label: response.source.type,
      } as TypeSelectOption);
    });
  }, [props.itemId]);

  console.log('RankingListPreviewProps', props);
  const [submitting, setSubmitting] = useState(false);

  const handleEnableChange = () => {
    setEnable(!enable);
  };

  const checkChannel = () => {
    if (channelRef.current && channelRef.current.getValue().length === 0) {
      setChannelrror(true);
      setChannelErrorMsg('channel is epmpty');
      return false;
    } else {
      setChannelrror(false);
      setChannelErrorMsg('');
    }
    return true;
  };

  const checkType = () => {
    if (typeRef.current && typeRef.current.getValue().length === 0) {
      setTypeError(true);
      setTypeErrorMsg('type is empty');
      return false;
    } else {
      setTypeError(false);
      setTypeErrorMsg('');
    }
    return true;
  };

  const checkSort = () => {
    if (sortRef.current && sortRef.current.value === '') {
      setSortError(true);
      setSortErrorMsg('order is empty');
      return false;
    } else {
      setSortError(false);
      setSortErrorMsg('');
    }
    return true;
  };

  const checkStartDate = () => {
    if (startDateRef.current && startDateRef.current.value == '') {
      setStartateError(true);
      setStartDateErrorMsg('startDate is empty');
      return false;
    } else {
      setStartateError(false);
      setStartDateErrorMsg('');
    }
    return true;
  };

  const checkEndDate = () => {
    if (endDateRef.current && endDateRef.current.value == '') {
      setEndError(true);
      setEndDateErrorMsg('endDate is empty');
      return false;
    } else {
      setEndError(false);
      setEndDateErrorMsg('');
    }
    return true;
  };

  const checkParams = () => {
    if (!checkType()) {
      return false;
    }
    if (!checkSort()) {
      return false;
    }
    if (!checkStartDate()) {
      return false;
    }
    if (!checkEndDate()) {
      return false;
    }
    if (!checkChannel()) {
      return false;
    }
    return true;
  };

  const submitChange = async () => {
    setSubmitting(true);
    if (!checkParams()) {
      setSubmitting(false);
      return;
    }
    const params = {
      order: parseInt(sort),
      startTime: new Date(startDate).getTime(),
      endTime: new Date(endDate).getTime(),
      enable: enable,
      type: customeType as RankingListType,
      channelIds: channel?.map((item) => item.value),
    } as RankingList;

    if (props.mode === 'ADD' && hotSearchType) {
      params.type = hotSearchType.value;
    }
    try {
      const rr = await HotsearchClient.editAndAddRankMeta(
        params,
        props.mode === 'ADD' ? 'POST' : 'PATCH',
        props.mode === 'ADD' ? '' : '/' + props.itemId + '/meta',
      );
      if (rr.ok) {
        props.onDismiss();
        props.updateItem(
          props.mode === 'ADD' ? 'Add Meta Success' : 'Edit Meta Success',
        );
      } else {
        setHasError(true);
        const data = await rr.json();
        if (data.error) {
          setErrorMsg(
            data.error[0].path[0]
              ? data.error[0].path.join(' ') + ' ' + data.error[0].message
              : data.error[0].message + ' is error',
          );
        } else {
          setErrorMsg(data.message);
        }
        setSubmitting(false);
      }
    } catch (error) {
      setSubmitting(false);
      console.error(error);
      setErrorMsg(error as string);
      setHasError(true);
    }
  };

  async function fetchAndConvertToRankingDetail(): Promise<RankingDetail> {
    const response = await HotsearchClient.queryRankById(props.itemId);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const json: RankingDetail = await response.json();
    return json;
  }

  const onDismiss = () => {
    props.onDismiss();
  };

  return (
    <>
      <Modal
        className='ranking-list-preview-modal'
        onDismiss={onDismiss}
        headerSlot={
          <h3 className='tw-text-lg tw-font-medium tw-text-center tw-bottom-2 tw-w-[35rem]'>
            {props.mode == 'EDIT' ? ' Edit Ranking Meta' : 'Add Ranking'}
          </h3>
        }
        isOpen={props.showModal}
      >
        <div className='tw-flex-col tw-pr-2'>
          {/* type sort */}
          <div className='tw-flex tw-mt-2  tw-gap-2'>
            <span
              style={{ padding: '10px' }}
              className='tw-h-10  tw-w-[7rem] tw-inline-block'
            >
              Type
            </span>
            {props.mode == 'EDIT' && (
              <div
                className='tw-w-full tw-text-left tw-text-[1.125rem] tw-font-medium'
                style={{ paddingTop: '10px' }}
              >
                {customeType == 'CUSTOMIZE'
                  ? 'HOT SEARCH'
                  : customeType
                  ? 'PRODUCT'
                  : ''}
              </div>
            )}
            {/* add start */}
            {props.mode == 'ADD' && (
              <div className='eds-text-field--select tw-w-full '>
                <EDSelect
                  className='eds-text-field--select'
                  id='onChange-example'
                  options={loadTypeOptions}
                  label='Example Label'
                  subtitle=''
                  errorMessage={typeErrorMsg}
                  hasErrors={typeError}
                  hideLabel
                  ref={typeRef}
                  onChange={(e) => {
                    //checkType();
                    if (e?.value === 'CUSTOMIZE') {
                      const newOption = {
                        value: 'CUSTOMIZE',
                        label: 'CUSTOMIZE',
                      } as TypeSelectOption;
                      setHotSearchType(newOption);
                      setChannelMultiSelect(false);
                      setChannel([]);
                    } else {
                      const newOption = {
                        value: 'GENERIC',
                        label: 'GENERIC',
                      } as TypeSelectOption;
                      setHotSearchType(newOption);
                      setChannelMultiSelect(true);
                    }
                    setTypeError(false);
                    setTypeErrorMsg('');
                  }}
                />
              </div>
            )}
            {/* add end */}
          </div>

          <div className='tw-flex tw-gap-2 tw-mt-4'>
            <span
              style={{ padding: '10px' }}
              className='tw-h-10  tw-w-[7.1rem] tw-inline-block'
            >
              Order
            </span>
            <div className='tw-w-full'>
              <TextField
                id='id'
                type='number' // default type
                min={0}
                label='Label'
                subtitle=''
                hideLabel
                hasErrors={sortError}
                errorMessage={sortErrorMsg}
                placeholder=''
                ref={sortRef}
                value={sort}
                onChange={(e) => {
                  // checkSort();
                  if (e.target.value == '') {
                    setSortError(true);
                    setSortErrorMsg('order is empty');
                  } else {
                    setSortError(false);
                    setSortErrorMsg('');
                  }
                  setSort(e.target.value);
                }}
              />
            </div>
          </div>

          <div className='tw-flex tw-gap-2 tw-mt-4'>
            <span
              style={{ padding: '10px' }}
              className='tw-h-10  tw-w-[7.1rem] tw-inline-block'
            >
              Start Date
            </span>
            <div className='tw-w-full'>
              <TextField
                id='id'
                type='datetime-local' // default type
                label='Label'
                subtitle=''
                hideLabel
                hasErrors={startDateError}
                errorMessage={startDateErrorMsg}
                placeholder=''
                ref={startDateRef}
                value={startDate}
                onChange={(e) => {
                  if (e.target.value == '') {
                    setStartateError(true);
                    setStartDateErrorMsg('startDate is empty');
                  } else {
                    setStartateError(false);
                    setStartDateErrorMsg('');
                  }
                  setStartDate(e.target.value);
                }}
              />
            </div>
          </div>

          <div className='tw-flex tw-gap-2 tw-mt-4'>
            <span
              style={{ padding: '10px' }}
              className='tw-h-10  tw-w-[7.1rem] tw-inline-block'
            >
              End Date
            </span>
            <div className='tw-w-full'>
              <TextField
                id='id'
                type='datetime-local' // default type
                label='Label'
                subtitle=''
                hideLabel
                hasErrors={endDateError}
                errorMessage={endDateErrorMsg}
                placeholder=''
                value={endDate}
                ref={endDateRef}
                onChange={(e) => {
                  if (e.target.value == '') {
                    setEndError(true);
                    setEndDateErrorMsg('endDate is empty');
                  } else {
                    setEndError(false);
                    setEndDateErrorMsg('');
                  }
                  setEndDate(e.target.value);
                }}
              />
            </div>
          </div>

          <div className='tw-flex tw-gap-2 tw-mt-4'>
            <span
              style={{ padding: '10px' }}
              className='tw-h-10  tw-w-[7.1rem] tw-inline-block'
            >
              Channel
            </span>
            <div className='tw-w-full tw-overflow-hidden'>
              <EDSelect
                className='tw-overflow-hidden'
                id='onChange-example'
                options={channelOptions}
                value={channel}
                label='Example Label'
                subtitle=''
                message=''
                isMulti={channelMultiSelect}
                menuPosition='fixed'
                ref={channelRef}
                hideLabel
                hasErrors={channelError}
                errorMessage={channeErrorlMsg}
                onChange={(e) => {
                  if (!e) {
                    setChannelrror(true);
                    setChannelErrorMsg('channel is empty');
                  } else {
                    setChannelrror(false);
                    setChannelErrorMsg('');
                  }
                  setChannel(
                    hotSearchType?.value == 'GENERIC'
                      ? (e as ChannelOption[])
                      : [e as ChannelOption],
                  );
                  console.log(channelOptions);
                }}
              />
            </div>
          </div>

          {/* Enable */}
          <div className='tw-flex tw-gap-2 tw-mt-4'>
            <span
              style={{ padding: '10px' }}
              className='tw-h-10  tw-w-[7.1rem] tw-inline-block'
            >
              Enable
            </span>
            <div
              className='tw-w-full tw-text-left tw-text-[1.125rem] tw-font-medium'
              style={{ paddingTop: '10px' }}
            >
              <Toggle
                id={nanoid(10)}
                label=''
                onClick={handleEnableChange}
                checked={enable}
              />
            </div>
          </div>

          {/* Button */}
          {/* {props.canWrite && ( */}
          <div className='tw-flex tw-gap-2 tw-mt-4 tw-mb-10'>
            <span
              style={{ padding: '10px' }}
              className='tw-h-10 tw-w-[35rem] tw-text-center'
            >
              <Button
                className='eds-button eds-button--primary eds-button--small'
                onClick={submitChange}
                disabled={submitting || !props.canWrite}
              >
                Save
              </Button>
            </span>
          </div>
          {/* )} */}

          {isImmediately && (
            <div className='tw-flex tw-gap-2 tw-mt-4'>
              <div
                className='tw-w-full'
                style={{
                  padding: '10px',
                  color: 'var(--eds-color-red-60)',
                  fontSize: '0.85rem',
                }}
              >
                This operation will immediately take effect
              </div>
            </div>
          )}
        </div>
        <Snackbar style={{ left: '90%', top: '90%' }}>
          {errorMsg != displayController.not_displayed && (
            <Snack
              autoDismissDuration={5000}
              id='pw-error-notification'
              onDismiss={(_id) => {
                setErrorMsg(displayController.not_displayed);
              }}
              status={hasError ? 'error' : 'success'}
            >
              {errorMsg ? errorMsg : 'Success'}
            </Snack>
          )}
        </Snackbar>
      </Modal>
    </>
  );
}
